import React, { useCallback, useState } from "react";
import {
  Card,
  CircularProgress,
  debounce,
  Drawer,
  TextField,
} from "@material-ui/core";
import { FaSearch } from "react-icons/fa";
import { AiFillCloseCircle } from "react-icons/ai";
import { FiSearch } from "react-icons/fi";
import { Shimmer, Image } from "react-shimmer";
import { Link } from "react-router-dom";

import styles from "./index.module.css";
import { api_call } from "../../utils/Network";
import { appendImageUrl, isMobiledevice } from "../../utils/helperFunctions";
import { Autocomplete } from "@material-ui/lab";

export default function Search() {
  const [searchList, setSearchList] = useState([]);
  const [searching, setSearching] = useState(false);
  const [searched, setSearched] = useState(false);
  const [searchDropdown, setSearchDropdown] = useState(false);
  const [searchDrawer, setSearchDrawer] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");

  React.useEffect(() => {
    if (!searchDropdown) setSearchList([]);
  }, [searchDropdown]);

  const searchHandler = useCallback(
    debounce((v) => {
      if (v) {
        setSearching(true);
        api_call
          .get(`service_list/service?size=12&search=${v}`)
          .then((res) => {
            if (res.status === 200 && res.data.results?.length) {
              setSearchList(res.data.results);
            } else setSearchList([]);
            setSearched(true);
            setSearching(false);
          })
          .catch((e) => console.log(e));
      }
    }, 1200),
    []
  );

  return (
    <>
      {searchDrawer && (
        <SearchDrawer
          onSearch={searchHandler}
          styles={styles}
          onClose={() => (
            setSearched(false), setSearchList([]), setSearchDrawer(false)
          )}
        >
          <div style={{ textAlign: "center" }} className={styles.mainContainer}>
            {searching ? (
              <CircularProgress />
            ) : searchList.length ? (
              <div className={styles.listContainer}>
                {searchList.map((service) => (
                  <Link
                    onClick={() => (
                      setSearched(false),
                      setSearchList([]),
                      setSearchDrawer(false)
                    )}
                    style={{ textDecoration: "none" }}
                    to={`/cart/${service.category_id}/${service.variant_id}/${
                      service.parent_id || service.service_id
                    }`}
                    key={service.service_id}
                  >
                    <div key={service.service_id} className={styles.service}>
                      <Image
                        src={
                          service.service_icon
                            ? appendImageUrl(service.service_icon)
                            : service.service_image
                            ? appendImageUrl(service.service_image)
                            : appendImageUrl(
                                "/files/files/Group_49_xVPEXu3.png"
                              )
                        }
                        NativeImgProps={{ className: styles.serviceImg }}
                        fallback={
                          <Shimmer
                            height={isMobiledevice() ? 70 : 100}
                            width={isMobiledevice() ? 70 : 100}
                            className={styles.serviceImg}
                          />
                        }
                      />
                      <div style={{ flex: 10 }}>
                        <h3 className={styles.serviceType}>
                          {service.service_name}
                        </h3>
                        {/* <p>{service.service_description}</p> */}
                        <p className={styles.ssDuration}>
                          Duration : {service.duration} | Crew : {service.crew}
                        </p>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : searched ? (
              "There are no such services."
            ) : (
              "Start typing to search servies."
            )}
          </div>
        </SearchDrawer>
      )}
      {window.innerWidth < 992 ? (
        <div style={{ display: "flex", alignItems: "center" }}>
          <FiSearch
            onClick={() => setSearchDrawer(true)}
            className={styles.searchIcon}
          />
          {!isMobiledevice() && (
            <h3
              onClick={() => setSearchDrawer(true)}
              className={styles.headetText}
            >
              Search
            </h3>
          )}
        </div>
      ) : (
        <div className={styles.searchBarSection}>
          <Autocomplete
            options={searchList}
            style={{ width: "100%" }}
            getOptionLabel={(option) => option.service_name || ""}
            noOptionsText={
              searched ? "There are no such service" : "Type to search service"
            }
            clearOnBlur
            renderOption={(service) => (
              <Link
                style={{ textDecoration: "none" }}
                to={`/cart/${service.category_id}/${service.variant_id}/${
                  service.parent_id || service.service_id
                }`}
              >
                <div key={service.service_id} className={styles.service}>
                  <Image
                    src={
                      service.service_icon
                        ? appendImageUrl(service.service_icon)
                        : service.service_image
                        ? appendImageUrl(service.service_image)
                        : appendImageUrl("/files/files/Group_49_xVPEXu3.png")
                    }
                    NativeImgProps={{ className: styles.serviceImg }}
                    fallback={
                      <Shimmer
                        height={isMobiledevice() ? 70 : 100}
                        width={isMobiledevice() ? 70 : 100}
                        className={styles.serviceImg}
                      />
                    }
                  />
                  <div>
                    <h3 className={styles.serviceType}>
                      {service.service_name}
                    </h3>
                    {/* <p>{service.service_description}</p> */}
                    <p className={styles.ssDuration}>
                      Duration : {service.duration} | Crew : {service.crew}
                    </p>
                  </div>
                </div>
              </Link>
            )}
            onChange={() => setSearchKeyword("")}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Search Services"
                variant="outlined"
                value={searchKeyword}
                onChange={(e) => (
                  setSearchKeyword(e.target.value),
                  searchHandler(e.target.value)
                )}
              />
            )}
            closeIcon={
              searchDropdown ? (
                <AiFillCloseCircle style={{ fontSize: 22 }} />
              ) : null
            }
            popupIcon={<FiSearch />}
            size="small"
            classes={{
              root: styles.searchInput,
              input: styles.searchInput,
              inputRoot: styles.searchInput,
              inputFocused: styles.searchInput,
              focused: styles.searchInput,
              popupIndicatorOpen: styles.dispNone,
            }}
            className={styles.searchInput}
            open={searchDropdown}
            onOpen={() => setSearchDropdown(true)}
            onClose={() => setSearchDropdown(false)}
          />
        </div>
      )}
    </>
  );
}

const SearchDrawer = ({ onClose, onSearch, styles, children }) => (
  <Drawer PaperProps={{ style: { width: "100%" } }} open onClose={onClose}>
    <div className={styles.searchbar_container}>
      <FaSearch
        className={styles.searchbar_icon}
        style={{ color: "#e4e2e2" }}
      />
      <input
        className={styles.searchbar_input}
        type="text"
        placeholder="Search Services"
        onInput={(e) => onSearch(e.target.value)}
      />
    </div>
    <AiFillCloseCircle
      className={styles.searchbar_close}
      style={{ color: "red" }}
      onClick={onClose}
    />
    <div className={styles.searchProductList}>{children}</div>
  </Drawer>
);
